module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-20.53adb14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-20.jpg
// module id = MRaT
// module chunks = 51